// covered-by: frontends/carrie/src/ask-v2/shell/__tests__/AskV2Layout.test.tsx
import { Outlet } from "@tanstack/react-router";

import { AskV2Sidebar } from "./AskV2Sidebar";

/**
 * Authenticated V2 chrome: left rail + page outlet. Isolated from
 * PunttLayout so tickets Documents never mount on ask.puntt.ai.
 */
export function AskV2Layout() {
  return (
    <div
      data-testid="ask-v2-shell"
      className="relative grid h-screen grid-cols-[auto_1fr] overflow-hidden bg-puntt-neutral-gray-2"
    >
      <AskV2Sidebar />
      <div
        className="flex h-full min-h-0 min-w-0 flex-col overflow-hidden"
        data-testid="ask-v2-outlet-shell"
      >
        <Outlet />
      </div>
    </div>
  );
}
